import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import TopBar from '../../components/TopBar'
import ErrorImage from '../../assets/motor/error_payment.png'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const styles = {}

class ErrorPayment extends Component {
  render() {
    return (
      <Wrapper>
        <div style={{ margin: '16px', marginTop: '66px' }}>
          <div
            style={{
              marginTop: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img
              alt="error_image"
              src={ErrorImage}
              style={{ width: '120px', height: '120px' }}
            />
          </div>
          <p
            style={{
              ...fontDefault,
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '18px',
              color: '#0e162c',
            }}
          >
            ซื้อประกันไม่สำเร็จ
          </p>
          <p
            style={{
              ...fontDefault,
              textAlign: 'center',
              fontSize: '16px',
              color: '#999999',
            }}
          >
            ไม่สามารถทำรายการชำระเงิน ได้ในขณะนี้ กรุณาทำรายการใหม่อีกครั้ง
          </p>
          <p
            style={{
              ...fontDefault,
              textAlign: 'center',
              fontSize: '16px',
              color: '#999999',
            }}
          >
            คุณสามารถช่วยเราปรับปรุงทรูมันนี่ วอลเล็ท
            เพื่อส่งมอบประสบการณ์การใช้งานที่ดียิ่งขึ้น
            ด้วยการแจ้งปัญหานี้ให้เราทราบ เพียงกดปุ่มด้านล่าง
          </p>
          <br />

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <a
              onClick={() => {
                const {
                  history: { push },
                } = this.props
                push('/send-report')
              }}
              style={{
                ...fontDefault,
                color: '#ff8300',
                padding: '7px 20px',
                fontWeight: 'bold',
                border: '1px solid #ff8300',
                borderRadius: '20px',
                backgroundColor: 'white',
                textDecoration: 'none',
              }}
            >
              ส่งรายงานเหตุขัดข้อง
            </a>
          </div>
        </div>
        <Header>
          <TopBar
            close={() => {
              window.location.replace('ascendmoney://closewebview')
            }}
          />
        </Header>
      </Wrapper>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {}
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ErrorPayment))
